import styles from './constStyles.module.scss';
import { SUPER_PROJECT_NAME } from 'src/constants/global';
import {
  ADDITIONAL_MAX_FEATURES_V2,
  ADDITIONAL_PRO_FEATURES_V2,
  ADDITIONAL_STANDARD_FEATURES_V2,
  ADDITIONAL_ULTRA_FEATURES_V2,
  BUSINESS_FEATURES_V2,
  INDIVIDUAL_FEATURES_V2,
  MAX_FEATURES_V2,
  NEW_BASE_MAX_USAGE_DATASET,
  PRO_FEATURES_V2,
  STANDARD_FEATURES_V2,
  ULTRA_FEATURES_V2,
} from 'src/constants/payments';

const MAX_COMMON_FEATURES = [
  {
    id: '3',
    title: (
      <span>
        <span className={styles.bold}>World’s Fastest</span> Deep research
        <span className={styles.secondary}> (3x-5x Faster)</span>
      </span>
    ),
  },
  {
    id: '4',
    title: <span>End-to-end coding w/ GitHub integration</span>,
  },
  { id: '5', title: 'Website creation' },
  { id: '6', title: 'Document creation' },
  { id: '7', title: 'Advanced research & insight' },
  { id: '8', title: 'Data analysis and visualization' },
  {
    id: '9',
    title: (
      <span>
        <span className={styles.bold}>20+</span> premium text AI models
      </span>
    ),
  },
  {
    id: '10',
    title: (
      <span>
        <span className={styles.bold}>10+</span> premium image & video AI models
      </span>
    ),
  },
];

const BUSINESS_COMMON_FEATURES = [
  {
    id: '3',
    title: (
      <span>
        <span className={styles.bold}>World’s Fastest</span> Deep research
        <span className={styles.secondary}> (3x-5x Faster)</span>
      </span>
    ),
  },
  {
    id: '4',
    title: <span>End-to-end coding w/ GitHub integration</span>,
  },
  { id: '5', title: 'Website creation' },
  { id: '6', title: 'Document creation' },
  { id: '7', title: 'Advanced research & insight' },
  { id: '8', title: 'Data analysis and visualization' },
  {
    id: '9',
    title: (
      <span>
        <span className={styles.bold}>20+</span> premium text AI models
      </span>
    ),
  },
  {
    id: '10',
    title: (
      <span>
        <span className={styles.bold}>10+</span> premium image & video AI models
      </span>
    ),
  },
  { id: '11', title: 'Opt out of data training' },
  { id: '12', title: 'Workspace management' },
  { id: '13', title: 'Pay-per-use API for Ninja models' },
];

export const FEATURES_ON_CANCELLATION = {
  PRO_10: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: 'Prompt improver',
    },
    {
      id: '3',
      title: 'Code generation & debug',
    },
    {
      id: '4',
      title: 'Image generation',
    },
    {
      id: '5',
      title: 'Creative and professional writing',
    },
    {
      id: '6',
      title: 'Fast search',
    },
    {
      id: '7',
      title: 'Generate podcasts',
    },
  ],
  PRO_30: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> Deep research
        </span>
      ),
    },
    {
      id: '3',
      title: (
        <span>
          <span className={styles.bold}>20+</span> premium text AI models
        </span>
      ),
    },
    {
      id: '4',
      title: (
        <span>
          <span className={styles.bold}>10+</span> premium image & video AI
          models
        </span>
      ),
    },
    {
      id: '5',
      title: 'Document and code editor',
    },
    {
      id: '6',
      title: 'File upload analysis up to 2M words',
    },
    {
      id: '7',
      title: 'Video generation',
    },
  ],
  MAX_10: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>150</span> {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    ...MAX_COMMON_FEATURES,
  ],
  MAX_20: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>300</span> {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    ...MAX_COMMON_FEATURES,
  ],
  MAX_30: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> {SUPER_PROJECT_NAME}{' '}
          tasks
        </span>
      ),
    },
    ...MAX_COMMON_FEATURES,
  ],
  BUSINESS_10: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>150</span> {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    ...BUSINESS_COMMON_FEATURES,
  ],
  BUSINESS_20: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>300</span> {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    ...BUSINESS_COMMON_FEATURES,
  ],
  BUSINESS_30: [
    {
      id: '1',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> chat tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <span className={styles.bold}>Unlimited</span> {SUPER_PROJECT_NAME}{' '}
          tasks
        </span>
      ),
    },
    ...BUSINESS_COMMON_FEATURES,
  ],
};

export const NEW_FEATURES_ON_CANCELLATION = {
  MAX_05: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['5'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['5'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machine
        </span>
      ),
    },
    ...STANDARD_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...ADDITIONAL_STANDARD_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
  ],
  MAX_10: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['10'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['10'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...PRO_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...INDIVIDUAL_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_PRO_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
  MAX_20: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['20'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['20'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...ULTRA_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...INDIVIDUAL_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_ULTRA_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
  MAX_30: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['unlimited'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['unlimited'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...MAX_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...INDIVIDUAL_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_MAX_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
  BUSINESS_10: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['b-10'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['b-10'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...PRO_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...BUSINESS_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_PRO_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
  BUSINESS_20: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['b-20'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['b-20'].concurrentTasksCount}</b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...ULTRA_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...BUSINESS_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_ULTRA_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
  BUSINESS_30: [
    {
      id: '1',
      title: (
        <span>
          <b>{NEW_BASE_MAX_USAGE_DATASET['b-unlimited'].requestCount}</b>{' '}
          {SUPER_PROJECT_NAME} tasks
        </span>
      ),
    },
    {
      id: '2',
      title: (
        <span>
          <b>
            {NEW_BASE_MAX_USAGE_DATASET['b-unlimited'].concurrentTasksCount}
          </b>{' '}
          Concurrent Virtual Machines
        </span>
      ),
    },
    ...MAX_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 3}`,
      title: item.title,
    })),
    ...BUSINESS_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 100}`,
      title: item.title,
    })),
    ...ADDITIONAL_MAX_FEATURES_V2.map((item, idx) => ({
      id: `${idx + 200}`,
      title: item.title,
    })),
  ],
};
